// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"17d2e467","89":"fee60351","195":"687d8235","205":"96de2e65","274":"b46c3cdc","353":"1aedebe5","546":"75843d38","678":"33eb4dd5","744":"83518688","885":"7589ca0a","963":"42d2dcb7"}[chunkId] + ".chunk.js";
};